import React from "react";
import { Card, Row, Col } from "antd";
import { useSelector } from "react-redux";
import { RiArrowGoBackFill } from "react-icons/ri";
import { EmailCampaignCreateForm } from "@components";

const EmailCampaignCreate = ({ history }) => {
  const { user } = useSelector((state) => state.auth);

  return (
    <>
      <Card style={{ borderRadius: "0", height: "100vh", overflowY: "auto" }}>
        <Row>
          <Col span={24}>
            <Row>
              <RiArrowGoBackFill
                style={{ fontSize: "2em", cursor: "pointer" }}
                onClick={() => {
                  // If user is superadmin, redirect to super admin email templates page
                  if (user?.role === "superadmin") {
                    history.push("/super-admin/email/email-campaigns");
                  } else if (user?.role === "marketing") {
                    history.push("/marketing-admin/email/email-campaigns");
                  }
                }}
              />
              <h3
                className="hp-mb-16"
                style={{
                  marginLeft: "1em",
                  fontSize: "1.75em",
                }}
              >
                Create an Email Campaign
              </h3>
            </Row>
            {/* Space */}
            <Row style={{ marginTop: "1em" }} />
            {/* Email Campaign Create Form */}
            <EmailCampaignCreateForm />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default EmailCampaignCreate;
